import { isEmpty } from '@jjj/components';
import actions from './actions';
import { createReducer } from '../../../../../../helpers/reducer';
import { keyBy } from '../../../../../../helpers/core';
import { t } from '../../../../../../i18n';

const initState = {
  editForm: null,
  loading: false,
  formInfo: {},
  saved: false,
  total: 0,
  isReasonEnabled: false,
  isCancellationPoliciesChecking: false,
  cancellation_policy: { may_apply: false },
  isCancellationFeeModalVisible: false,
};

const initBackupData = {
  backupQuantity: 0,
  reason: '',
  description: '',
};

const fieldNameMap = {
  reason: 'admin_backup_action_reason_id',
  backupQuantity: 'backup_workers_required',
};

function validate(state, attr, value) {
  let error = '';

  if (attr === 'reason' && state.isReasonEnabled) {
    if (isEmpty(value)) {
      error = t('dash.validation.choose_a_field', { fieldName: t('dash.jobs.bookings.reason_label') });
    }
  }

  return error;
}

function getError(fieldName, errorObject) {
  let outputString = '';

  if (errorObject[fieldName]) {
    errorObject[fieldName].forEach((item, index, array) => {
      if (array.length - 1 === index) {
        outputString += `${item} `;
      } else {
        outputString += `${item}, `;
      }
    });
  }

  return outputString;
}

function onLoad(state, { payload }) {
  const editObject = {
    ...initBackupData,
    backupQuantity: payload.state?.currentBackupsAmount || 0,
  };
  const propsArray = Object.keys(editObject);
  const editForm = keyBy(
    propsArray,
    prop => prop,
    prop => ({
      name: prop,
      value: editObject[prop],
      error: validate(state, prop, editObject[prop]),
      touched: false,
    }),
  );

  return {
    ...state,
    editForm,
  };
}

function onLoadFormDataSuccess(state, { payload }) {
  const { backup_action_reasons } = payload.data;

  return {
    ...state,
    formInfo: { backup_action_reasons },
  };
}

function onLoadSuccess(state, { payload }) {
  const { data, total, filteredTotal } = payload;
  const backupsData = data;

  return {
    ...state,
    backupsData,
    total,
    filteredTotal,
    loading: false,
  };
}

function onClearStore() {
  return { ...initState };
}

function onSaveSuccess(state) {
  return {
    ...state,
    saved: true,
  };
}

function onSaveError(state, { payload }) {
  const { data } = payload;

  const propsArray = Object.entries(state.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        error: getError(fieldNameMap[entry[0]], data),
        touched: true,
      };
    },
  );

  const baseError = data.base ? data.base[0] : null;

  return {
    ...state,
    editForm,
    baseError,
  };
}

function onChangeProperty(state, { payload }) {
  const { attr, value } = payload;
  const { editForm } = state;

  editForm[attr] = {
    value,
    error: validate(state, attr, value),
    name: attr,
    touched: true,
  };

  return {
    ...state,
    editForm: {
      ...editForm,
    },
  };
}

function onCancel(state) {
  return {
    ...state,
    isEdit: false,
    editForm: null,
  };
}

function onTouch(state, { payload }) {
  const propsArray = Object.entries(payload.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [, value] = entry;

      return {
        ...value,
        touched: true,
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

function onSetReasonEnabled(state, { payload }) {
  const { isReasonEnabled } = payload;

  return {
    ...state,
    isReasonEnabled,
  };
}

function onValidate(state, { payload }) {
  const propsArray = Object.entries(payload.editForm);
  const editForm = keyBy(
    propsArray,
    entry => entry[0],
    entry => {
      const [prop, value] = entry;

      return {
        ...value,
        error: validate(state, prop, value),
      };
    },
  );

  return {
    ...state,
    editForm,
  };
}

function onCheckCancellationPoliciesRequest(state) {
  return {
    ...state,
    isCancellationPoliciesChecking: true,
  };
}

function onCheckCancellationPoliciesSuccess(state, { payload }) {
  return {
    ...state,
    isCancellationPoliciesChecking: false,
    cancellation_policy: { may_apply: payload.cancellation_policy_may_apply },
  };
}

function onToggleCancellationPolicyModal(state, { payload }) {
  const { isCancellationFeeModalVisible } = payload;

  return {
    ...state,
    isCancellationFeeModalVisible,
  };
}

export { validate };
export default createReducer(initState, {
  [actions.LOAD]: onLoad,
  [actions.LOAD_SUCCESS]: onLoadSuccess,
  [actions.CLEAR_STORE]: onClearStore,
  [actions.CHANGE_PROPERTY]: onChangeProperty,
  [actions.CANCEL]: onCancel,
  [actions.SAVE_SUCCESS]: onSaveSuccess,
  [actions.TOUCH]: onTouch,
  [actions.LOAD_FORM_DATA_SUCCESS]: onLoadFormDataSuccess,
  [actions.SET_REASON_ENABLED]: onSetReasonEnabled,
  [actions.VALIDATE]: onValidate,
  [actions.SAVE_ERROR]: onSaveError,
  [actions.CHECK_CANCELLATION_POLICIES_REQUEST]: onCheckCancellationPoliciesRequest,
  [actions.CHECK_CANCELLATION_POLICIES_SUCCESS]: onCheckCancellationPoliciesSuccess,
  [actions.TOGGLE_CANCELLATION_POLICY_CONFIRMATION_MODAL]: onToggleCancellationPolicyModal,
});
